import React from 'react';
import { Field, NumericInput, RadioGroup } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { WorksheetEquipmentDropdown, IWithWorksheetInjectedProps } from '../../../Core';
import { useSelector } from 'react-redux';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

let PreparationDrySection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const ovenDried = useSelector(pipe(createWorksheetSelector!('Preparation.MaterialDriedBy'), (d) => d === 'Oven'));
  const guardSieveUsed = useSelector(
    pipe(createWorksheetSelector!('Preparation.GuardSieveUsed'), valueOrDefault(false))
  );

  return (
    <>
      <ListFieldSection heading="Dry Preparation">
        <Field
          input={<RadioGroup />}
          name="Preparation.MaterialDriedBy"
          label="Initial Drying"
          options={[
            { label: 'Oven Dried', value: 'Oven' },
            { label: 'Air Dried', value: 'Air' },
          ]}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="oven"
          label="Oven"
          name="Preparation.Oven"
          visible={ovenDried}
        />
      </ListFieldSection>
      <ListFieldSection>
        <WorksheetBalanceFieldSet label="Balance" name="Preparation.Balance" />
        <Field input={<NumericInput />} name="Preparation.OriginalSampleMass" label="Original Mass of Sample" />
      </ListFieldSection>
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name="Preparation.PreparationProcessingMethod"
          label="Processing Method"
          freeEntry={true}
          freeEntryLabel="Other"
          options={[
            { label: 'Mortar & Pestle', value: 'Mortar & Pestle' },
            { label: 'Rollerdrum', value: 'Rollerdrum' },
          ]}
        />
        <Field
          input={<RadioGroup />}
          label="No. 4 (4.75 mm) Sieve Used Over No. 10 (2.00 mm) Sieve?"
          name="Preparation.GuardSieveUsed"
          options={[
            { value: true, label: 'Yes' },
            { value: false, label: 'No' },
          ]}
        />
      </ListFieldSection>
      <ListFieldSection>
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="No. 4 (4.75 mm) Sieve"
          equipmentType="sieve"
          name="Preparation.CoarseGuardSieve"
          queryParams={{ SieveSize: '0.00475 m' }}
          visible={guardSieveUsed}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="No. 10 (2.00 mm) Sieve"
          equipmentType="sieve"
          name="Preparation.GuardSieve"
          queryParams={{ SieveSize: '0.002 m' }}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="No. 40 (425 µm) Sieve"
          equipmentType="sieve"
          name="Preparation.OversizeSieve"
          queryParams={{ SieveSize: '0.000425 m' }}
        />
        <Field
          input={<NumericInput />}
          name="Preparation.PassingPortionMass"
          label="Mass of Passing Portion Selected for Test"
        />
      </ListFieldSection>
    </>
  );
};

PreparationDrySection = withInjectedProps(PreparationDrySection);

export { PreparationDrySection };
export default PreparationDrySection;
